import { Injectable } from '@angular/core';
import { Order, QueryEntity } from '@datorama/akita';
import { compareEntities } from '@lycoris-nubila/ngx-lycoris';
import { isNil, reject, uniqBy } from 'lodash-es';
import { Observable } from 'rxjs';
import { distinctUntilChanged, map, shareReplay } from 'rxjs/operators';

import { ModuleTask } from 'module/page/task/module-task';
import { ModuleTaskRepositoryPort } from 'module/page/task/port/module-task-repository.port';

import { CacheObservable } from '../../../../app-decorators';
import { ModuleTaskState, ModuleTaskStore } from './module-task.types';

@Injectable()
export class ModuleTaskRepositoryAdapter
	extends QueryEntity<ModuleTaskState>
	implements ModuleTaskRepositoryPort
{
	constructor(protected store: ModuleTaskStore) {
		super(store);
	}

	@CacheObservable()
	public observeModuleTasksByIds(tasksId: string[]): Observable<ModuleTask[]> {
		return this.selectAll({
			filterBy: (entity) => tasksId.includes(entity.id),
			sortByOrder: Order.ASC,
			sortBy: 'position',
		}).pipe(
			map((documents) =>
				documents.map((document) => this.store.asEntity(document))
			),
			distinctUntilChanged(compareEntities),
			shareReplay({ bufferSize: 1, refCount: true })
		);
	}

	public async saveModuleTasks(entities: ModuleTask[]): Promise<void> {
		this.store.upsertMany(
			uniqBy(
				reject(entities, isNil).map((e) => this.store.asDocument(e)),
				'id'
			)
		);
	}
}
